export default __webpack_public_path__ + "static/laptop-bg-66783e76e3184d831786b7c6a46b43fb.png";